export default __webpack_public_path__ + "c40587b5ec297197443684280c3484ad.png";